import ExcelJS from "exceljs";

/**
 * @param {unknown[][]} rows - Array of rows; each cell is stringified (null/undefined → '')
 * @param {string} filenameBase - Without extension; invalid path chars are stripped
 * @param {string} [sheetName='Export']
 * @returns {Promise<void>}
 */
export async function downloadXlsxFromMatrix(rows, filenameBase, sheetName = "Export") {
  if (!Array.isArray(rows) || rows.length === 0) {
    window.alert("No data to export.");
    return;
  }
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet(sheetName.length > 31 ? sheetName.slice(0, 31) : sheetName);
  rows.forEach((row) => {
    if (!Array.isArray(row)) {
      sheet.addRow([row == null ? "" : row]);
    } else {
      sheet.addRow(
        row.map((cell) => {
          if (cell == null) return "";
          if (typeof cell === "object" && cell !== null && !Array.isArray(cell)) {
            try {
              return JSON.stringify(cell);
            } catch (_e) {
              return String(cell);
            }
          }
          return cell;
        })
      );
    }
  });
  const buffer = await workbook.xlsx.writeBuffer();
  const safe = `${String(filenameBase || "export")}`.replace(/[/\\?%*:|"<>]/g, "-");
  const filename = safe.toLowerCase().endsWith(".xlsx") ? safe : `${safe}.xlsx`;
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
